import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CitationRefNavEditing from './citationrefnavediting';
import CitationRefNavUI from './citationrefnavcommand';

export default class CitationRefNav extends Plugin {
  static get pluginName() {
    return 'CitationRefNav';
  }
  static get requires() {
    return [ CitationRefNavEditing, CitationRefNavUI ];
  }
}
